export default function setSocialPosition({position}) {
  document.documentElement.style.setProperty('--socialPosition', position);
}